module.exports = __webpack_public_path__ + "img/controle-sua-casa-pela-tv.2a212aee.png";